<mat-form-field>
  <input matInput (dateChange)="updateDateTime()" [placeholder]="placeholder" [matDatepicker]="fromDatepicker"
    [(ngModel)]="date" [disabled]="disabled">
  <mat-datepicker-toggle matSuffix [for]="fromDatepicker"></mat-datepicker-toggle>
  <mat-datepicker #fromDatepicker></mat-datepicker>
</mat-form-field>
<mat-form-field style="margin-left: 10px">
  <input matInput (change)="updateDateTime()" type="time" placeholder="Uhrzeit" [(ngModel)]="time" [disabled]="disabled">
</mat-form-field>
